var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPepsiLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ohi007w4va"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 11",
    style: {
      fill: "none"
    },
    d: "M0 0h40v40H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 150",
    style: {
      clipPath: "url(#ohi007w4va)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1",
    d: "M22.684 3.323A19.361 19.361 0 1 1 3.323 22.684 19.362 19.362 0 0 1 22.684 3.323",
    transform: "translate(-2.581 -2.788)",
    style: {
      fill: "#fff"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2",
    d: "M20.1.535A19.361 19.361 0 1 1 .742 19.893 19.362 19.362 0 0 1 20.1.535m0-.742a20.109 20.109 0 0 0-7.825 38.627A20.11 20.11 0 0 0 27.929 1.373 19.979 19.979 0 0 0 20.1-.207"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3",
    d: "M16 20.217a23.545 23.545 0 0 0 7.261 1.271c6.073 0 12.386-2.246 18.641-2.246a22.565 22.565 0 0 1 7.149.975A18.034 18.034 0 0 0 32.545 9.381 18.227 18.227 0 0 0 16 20.217",
    transform: "translate(-12.425 -7.493)",
    style: {
      fill: "#ff1400"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4",
    d: "M49.094 117.786a23.545 23.545 0 0 0-7.261-1.271c-6.073 0-12.386 2.246-18.641 2.246a22.565 22.565 0 0 1-7.149-.975 18.034 18.034 0 0 0 16.506 10.836 18.227 18.227 0 0 0 16.546-10.836",
    transform: "translate(-12.459 -90.696)",
    style: {
      fill: "#0e0e96"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5",
    d: "M11.252 16.157h6.461v1.845h-3.9v.954h3.067v1.775h-3.068v.954h3.945v1.845h-6.505zm22.885 7.374h2.608v-7.493l-2.589.917zm-8.32-1.619c.486 1.264 1.936 1.866 4.1 1.866 2.058 0 3.5-.884 3.5-2.445 0-2.706-4.588-2.036-4.588-3.023 0-.286.331-.5.919-.5.814 0 1.26.261 1.425.786l2.073-.784c-.26-1.031-1.3-1.818-3.574-1.818-1.917 0-3.333.828-3.333 2.345 0 2.823 4.588 2.1 4.588 3.138 0 .315-.326.5-1.021.5-1.045 0-1.744-.26-2.026-.839zm-17.973-.473-1.839.688v1.405h-2.56v-7.374h3.989c2.072 0 3.106.89 3.106 2.47 0 1.636-1.139 2.24-2.694 2.811m-.8-3.438h-1.04v2.212l.969-.392c.62-.233.969-.507.969-1.078 0-.47-.331-.742-.9-.742m16.142 3.438-1.839.688v1.405h-2.562v-7.374h3.989c2.072 0 3.106.89 3.106 2.47 0 1.636-1.139 2.24-2.694 2.811m-.8-3.438h-1.04v2.212l.969-.392c.62-.233.969-.507.969-1.078 0-.47-.331-.742-.9-.742"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPepsiLogo);
export default __webpack_public_path__ + "static/media/PepsiLogo.82b6ee32c66958b07575b426f377def6.svg";
export { ForwardRef as ReactComponent };